module.exports = __webpack_public_path__ + "img/835883ae49c91fa029af56a6117ccc2e.png";